import apiClient, { uploadMultipart } from './apiClient';

// List resources
export const getResources = (params = {}) => {
  const { query = '', type = '' } = params;
  let url = '/resources';
  const searchParams = [];
  if (query) searchParams.push(`query=${encodeURIComponent(query)}`);
  if (type) searchParams.push(`type=${encodeURIComponent(type)}`);
  if (searchParams.length) url += `?${searchParams.join('&')}`;
  return apiClient(url);
};

// Upload resource (handles chunked and non-chunked)
export const uploadResource = async ({ title, type, file }) => {
  const formData = new FormData();
  formData.append('title', title);
  formData.append('type', type);
  formData.append('file', file);
  const isChunk = file.size > 5 * 1024 * 1024;
  return uploadMultipart('/resources', formData, { chunk: isChunk });
};

// Get courses for a resource
export const getResourceCourses = (resourceId) => apiClient(`/resources/${resourceId}/courses`);

// Assign/unassign resource to a course
export const setResourceCourseAssignment = (resourceId, courseId, assigned) =>
  apiClient(`/resources/${resourceId}`, {
    method: 'POST',
    body: { course_id: courseId, assigned },
  }); 